<template>
  <div class="tile is-parent is-vertical">
    <p class="formtitle">Cadastrar Nova Grade</p>

    <article class="tile is-child notification formbox">
      <form @submit.prevent="validate">
        <b-field grouped group-multiline>
          <b-field
            class="column is-4"
            label="nome"
            :type="{'is-danger': errors.has('nome')}"
            :message="errors.first('nome')"
          >
            <b-input v-model="grade.nome" v-validate="'required'" name="nome"></b-input>
          </b-field>
          <b-field
            class="column is-4"
            label="nota maxíma"
            :type="{'is-danger': errors.has('nota_maxima')}"
            :message="errors.first('nota_maxima')"
          >
            <b-input v-model="grade.nota_maxima" name="nota_maxima"></b-input>
          </b-field>
        </b-field>
        <table class="table">
          <thead>
            <tr>
              <td>
                <strong>Nome</strong>
              </td>
              <td>
                <strong>Descrição</strong>
              </td>
              <td>
                <strong>Nota Máxima</strong>
              </td>
              <td>
                <strong>Nota Escala</strong>
              </td>
              <td>
                <strong>Peso</strong>
              </td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in grade.criterios" :key="index">
              <td>
                <input type="text" v-model="row.nome" />
              </td>
              <td>
                <input type="text" v-model="row.descricao" />
              </td>
              <td>
                <input type="text" v-model="row.nota_maxima" />
              </td>
              <td>
                <input type="text" v-model="row.nota_escala" />
              </td>
              <td>
                <input type="text" v-model="row.peso" />
              </td>
              <td>
                <a v-on:click="removeElement(index);" style="cursor: pointer">Remover</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="control has-text-centered">
          <b-button class="button cancelbutton">Cancelar</b-button>
          <button type="submit" class="button updatebutton" :disabled="!isFormValid">{{buttom}}</button>
        </div>
      </form>
    </article>
    <div class="buttons-adicional">
      <b-button class="button addcriterio" @click="addRow">
        <p>ADICIONAR CRÍTERIO</p>
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  name: "GradeForm",
  props: ["grade", "buttom"],
  methods: {
    addRow: function() {
      this.grade.criterios.push({
        nome: "",
        descricao: "",
        nota_maxima: "",
        nota_escala: "",
        peso: ""
      });
    },
    removeElement: function(index) {
      this.grade.criterios.splice(index, 1);
    },
    validate() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let self = this;

          this.$emit("formSubmit", self.grade, () => {});
        }
      });
    }
  },
  components: {},
  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some(key => this.fields[key].invalid);
    }
  },
  created() {}
};
</script>
